// src/App.js
import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import DemoForm from './components/DemoForm';
import ThankYou from './pages/Thankyou';
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Cookies from "./pages/Cookies";
import License from "./pages/License";
import NotFound from "./pages/NotFound";
import Pricing from "./pages/Pricing";
import About from './pages/About';

function App() {
    const location = useLocation();

    return (
        <div className="App">
            <main>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/form" element={<Navigate to="/demo" replace state={location.state} />} />
                    <Route path="/demo" element={<DemoForm />} />
                    <Route path="/pricing" element={<Pricing />} /> {/* Form Route */}
                    <Route path="/about" element={<About />} />
                    <Route path="/thank-you" element={<ThankYou />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="/cookies" element={<Cookies />} />
                    <Route path="/license" element={<License />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </main>
        </div>
    );
}

export default App;
